module.exports = __webpack_public_path__ + "img/qiancai-back-people@3x.0bbb0355.png";